import script from "./selectaccount.vue?vue&type=script&setup=true&lang=js"
export * from "./selectaccount.vue?vue&type=script&setup=true&lang=js"

import "./selectaccount.vue?vue&type=style&index=0&id=3732f98c&scoped=true&lang=css"

import exportComponent from "F:\\proj-abhinav\\meraki\\patient-portal-v3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3732f98c"]])

export default __exports__